<template>
    <div class="edit_block">
        <img src="@/assets/icons/ic_trash_black.svg" alt="" class="no_def_dragging cursor_pointer"
             @click="deleteClick()" v-if="this.settings.handleDeleteClick">
        <img src="@/assets/icons/ic_edit_item.svg" alt="" class="no_def_dragging cursor_pointer" @click="editClick()"
             v-if="this.settings.handleEditClick">
        <img src="@/assets/icons/ic_move_item.svg" alt="" class="no_def_dragging cursor_move"
             @click="handleDrag($event, settings.parentId)">
    </div>
</template>

<script>
import {handleClick} from "@/helpers/moving";

export default {
    name: "pdfGenerationActions",
    data() {
        return {
            lol: '',
        }
    },
    props: {
        settings: {
            type: [Object, null],
            default: () => {
                return {}
            }
        },
    },
    methods: {

        editClick() {
            console.log(`editClick`)
            this.settings.handleEditClick(this.settings.parentId)
        },
        deleteClick() {
            console.log(`deleteClick`)
            this.settings.handleDeleteClick(this.settings.parentId)
        },
        handleDrag(e, parentId) {
            let el = document.getElementById(parentId)
            console.log(`handleDrag: z:${this.settings.getLatestZIndex()}`)
            handleClick(e, el, this.settings.getLatestZIndex(), this.settings.config.moveStep, (left, top) => {
                if (left) {
                    if (this.settings.changePositionHandler) {
                        this.settings.changePositionHandler(this.settings.parentId, left, null)
                    }
                }
                if (top) {
                    if (this.settings.changePositionHandler) {
                        this.settings.changePositionHandler(this.settings.parentId, null, top)
                    }
                }
            })
        },
    }

}
</script>

<style scoped>
.cursor_move {
    cursor: move;
}

.no_def_dragging {
    user-drag: none;
    -webkit-user-drag: none;
    user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
}

.edit_block {
    position: absolute;
    top: 0;
    right: 0;
    background: #ffffff80;
    visibility: hidden;
    z-index: 999999999;
    display: flex;
}
.edit_block img {

}

.cursor_pointer {
    cursor: pointer;
}

</style>